




























import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwDropdownUnit } from '../dropdown-dir';
import { SwIcon, IconConfig } from '../sw-icon';

const cssPrefix = 'sw-select-option';

@Component({
  components: {
    SwDropdownUnit,
    SwIcon,
  },
})
export default class SwSelectOption extends SwExtendedVue {
  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Boolean, default: false })
  selected: boolean;

  @Prop({ type: Boolean, default: false })
  highlight: boolean;

  cssPrefix = cssPrefix;

  get effectiveCheckIconConfig(): IconConfig {
    return {
      name: 'checkmark',
      size: 14,
    };
  }
}
